const GeoreferencedSearchPlate = ({plate}) => {
    const getColor = () => {
        if(plate.formattedValue === "-") return "#fff"
        if(plate.pattern === "BRAZIL_MERCOSUL") return "#0067cb"
        return "#e8e8e8"
    }

    return(
        <div className="rounded border border-[#abababdd] flex flex-col w-[115px] justify-center items-center">
            <div className="h-[7px] w-full"
                style={{backgroundColor: getColor()}}
            ></div>
            <span className="text-[20px] text-center text-black w-full mx-auto"
                style={{backgroundColor: plate.pattern === "BRAZIL_LEGACY" ? "#cfcfcf" : "#fff"}}>{plate.formattedValue}</span>
        </div>
    )
}

export default GeoreferencedSearchPlate;